import "../../css2/CompletionScreen.css";

// Shown after reflection is submitted. Celebrates the completed exercise.

export default function CompletionScreen({ exerciseTitle, onClose, onDone }) {
  return (
    <div className="completion-screen">
      <button
        className="completion-screen__close"
        onClick={onClose}
        aria-label="Close"
      >
        ✕
      </button>

      <div className="completion-screen__inner">
        <div className="completion-screen__badge">🎖️</div>

        <h1 className="completion-screen__title">You showed up for yourself.</h1>
        <p className="completion-screen__subtitle">
          <em>{exerciseTitle}</em> is complete. That counts.
        </p>

        <div className="completion-screen__orb-wrap">
          <div className="completion-screen__glow" />
          <div className="completion-screen__orb">🌸</div>
        </div>

        <p className="completion-screen__caption">
          Every act of self-care lights a star in your universe.
        </p>

        <button className="completion-screen__done" onClick={onDone}>
          Done
        </button>
      </div>
    </div>
  );
}
